// extracted by mini-css-extract-plugin
export default {"headerText":"OBWWvg","variantGradient":"PLykkr"};